import { render, staticRenderFns } from "./academic_data_tab.vue?vue&type=template&id=33952ae3&scoped=true"
import script from "./academic_data_tab.vue?vue&type=script&lang=js"
export * from "./academic_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33952ae3",
  null
  
)

export default component.exports